export default {
  'not-found': 'Pagina niet gevonden',
  'internal-error': 'Verzoek kan niet worden verwerkt',
  'preview-error':
    '<strong>De slug van het artikel is niet geldig</strong>.<br/> Zorg ervoor dat het slug-veld is ingevuld en dat het artikel is <strong>Gepubliceerd</strong> of <strong>opgeslagen als Concept</strong>.',
  continue: 'Ga door met navigeren',
}
